export default {"src":"/_next/static/media/matterport-hotel.a30f2a8e.svg","height":43,"width":43,"blurWidth":0,"blurHeight":0};